import { Link } from "react-router-dom";

export const AMERIBAR_LOGO = "/logo.png";

export const BrandLogo = ({ size = "default", linkTo = "/" }) => {
    const content = (
        <div className="flex items-center gap-2">
            <span className={`font-heading font-black text-white ${size === "large" ? "text-2xl" : "text-xl"}`}>
                BarExam<span className="text-[#299dce]">Game</span><span className="text-slate-400">.com</span>
            </span>
        </div>
    );
    
    if (linkTo) {
        return <Link to={linkTo}>{content}</Link>;
    }
    return content;
};

export const BrandLogoWithAmeribar = ({ size = "default" }) => (
    <div className="flex items-center gap-3">
        <BrandLogo size={size} linkTo={null} />
        <span className="text-slate-600">|</span>
        <div className="flex items-center gap-2">
            <span className="text-slate-500 text-xs">by</span>
            <img src={AMERIBAR_LOGO} alt="AmeriBar" className="h-5 object-contain" />
        </div>
    </div>
);
